export const DOCS_PATH = 'docs';
